import { strParamsToArray, formatArrayToString } from './utils/strings';

export function formatCategoryParam (params) {
    const categoryParam = params?.category && `"${params?.category}"`;
    return `&category=${encodeURIComponent(categoryParam)}`;
}

export function formatCalendarReferenceParam (params) {
    const formatedCalendarReference = formatArrayToString(strParamsToArray(params?.calendar_reference));
    return `&calendar_reference=${encodeURIComponent(formatedCalendarReference)}`;
}

export function attachScheduleFilteringParams (params) {
    let scheduleFilteringParam = '';
    if (params?.category) {
        const encodedCategoryParam = formatCategoryParam(params);
        scheduleFilteringParam = encodedCategoryParam;
    }
    if (params?.calendar_reference) {
        const encodedCalendarReferenceParam = formatCalendarReferenceParam(params);
        scheduleFilteringParam = encodedCalendarReferenceParam;
    }
    return scheduleFilteringParam;
}